import { foxtrotGreyColor } from 'styled-ui-kit/colors';

const useCustomSelectTheme = () => {
  return theme => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: foxtrotGreyColor,
      primary25: foxtrotGreyColor,
      primary50: foxtrotGreyColor
    }
  });
};

export default useCustomSelectTheme;
